import React from 'react';
import { Form } from 'react-bootstrap';

/**
 * Компонент для управления SEO-метатегами
 * @param {Object} props - Свойства компонента
 * @param {Object} props.seoMetatags - Объект с метатегами
 * @param {Function} props.onChange - Функция, вызываемая при изменении метатегов
 * @returns {JSX.Element}
 */
export const SEOMetatagsForm = ({ seoMetatags = {}, onChange }) => {
  const handleChange = (field, value) => {
    // Создаем обновленный объект сео тегов
    const updatedMetatags = {
      ...seoMetatags,
      [field]: value,
    };
    
    // Также добавляем соответствующее поле с маленькой буквы для API
    if (field === 'Title') updatedMetatags.title = value;
    if (field === 'Description') updatedMetatags.description = value;
    if (field === 'Keywords') updatedMetatags.keywords = value;
    
    onChange(updatedMetatags);
  };

  return (
    <div>
      <Form.Group className="mb-3">
        <Form.Label>Title (заголовок страницы)</Form.Label>
        <Form.Control
          type="text"
          placeholder="Введите заголовок страницы"
          value={seoMetatags?.Title || seoMetatags?.title || ''}
          onChange={(e) => handleChange('Title', e.target.value)}
        />
        <Form.Text className="text-muted">Заголовок страницы для поисковых систем</Form.Text>
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Description (описание)</Form.Label>
        <Form.Control
          as="textarea"
          rows={3}
          placeholder="Введите описание страницы"
          value={seoMetatags?.Description || seoMetatags?.description || ''}
          onChange={(e) => handleChange('Description', e.target.value)}
        />
        <Form.Text className="text-muted">Краткое описание страницы для поисковых систем (рекомендуется 150-160 символов)</Form.Text>
      </Form.Group>

      <Form.Group className="mb-0">
        <Form.Label>Keywords (ключевые слова)</Form.Label>
        <Form.Control
          type="text"
          placeholder="Введите ключевые слова через запятую"
          value={seoMetatags?.Keywords || seoMetatags?.keywords || ''}
          onChange={(e) => handleChange('Keywords', e.target.value)}
        />
        <Form.Text className="text-muted">
          Ключевые слова для поисковых систем, разделенные запятыми
        </Form.Text>
      </Form.Group>
    </div>
  );
};
